const feedback = {
  feedback: ['FEEDBACK'] as const,
};

export default feedback;
